import PollBasicModel from "./PollBasicModel";

export default class PollFullModel extends PollBasicModel {
  public rules: string = null;
}
